import { getAnnualApproveList,batchUpdateAudit,updateAudit } from "../../api/config/modules/AnnualReview";

const state = {
    getAnnualApproveList: {},
    batchUpdateAudit: {},
    updateAudit: {},
};

const mutations = {
  SET_GETANNUALAPPROVELIST: (state, getAnnualApproveList) => {
    state.getAnnualApproveList = getAnnualApproveList;
  },
  SET_BATCHUPDATEAUDIT: (state, batchUpdateAudit) => {
    state.batchUpdateAudit = batchUpdateAudit;
  },
  SET_UPDATEAUDIT: (state, updateAudit) => {
    state.updateAudit = updateAudit;
  },
};

const actions = {
  GET_GETANNUALAPPROVELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getAnnualApproveList(data)
        .then((res) => {
          commit("SET_GETANNUALAPPROVELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_BATCHUPDATEAUDIT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        batchUpdateAudit(data)
        .then((res) => {
          commit("SET_BATCHUPDATEAUDIT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEAUDIT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateAudit(data)
        .then((res) => {
          commit("SET_UPDATEAUDIT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
